





























import {
  computed,
  defineComponent,
  PropType,
  reactive,
  toRefs
} from "@vue/composition-api";
import "@/components/icons";
import { Data, Props } from "./types";
import { ApiResponse } from "@/api/types";

const STUDENT_TREND_CATEGORIES = [
  { name: "MEMBER_REGISTRATION_COUNT" as const, label: "会員登録数" },
  { name: "EVENT_ENTRY_COUNT" as const, label: "エントリー数" },
  { name: "OFFER_RESULT_COUNT" as const, label: "内定数" }
];

export default defineComponent({
  name: "StudentTrendCategorySelectBox",
  model: {
    prop: "selectedStudentTrendCategory",
    event: "input"
  },
  props: {
    selectedStudentTrendCategory: {
      type: String as PropType<Props["selectedStudentTrendCategory"]>,
      required: true
    }
  },
  setup(props, { emit }) {
    const state = reactive<Data>({
      studentTrendCategories: STUDENT_TREND_CATEGORIES
    });

    const label = computed(() => {
      const studentTrendCategory = state.studentTrendCategories.find(
        e => e.name === props.selectedStudentTrendCategory
      );
      if (!studentTrendCategory || !studentTrendCategory.name) return "";
      return studentTrendCategory.label;
    });

    const updateSelectedStudentTrendCategory = (event: Event) => {
      const targetStudentTrendCategory = (event.target as HTMLInputElement)
        .value as ApiResponse.GraphCategory;
      emit("input", targetStudentTrendCategory);
    };

    return {
      ...toRefs(state),
      label,
      updateSelectedStudentTrendCategory
    };
  }
});
